import React, { useState } from "react";
import axios from "axios";
import { Link,useNavigate } from "react-router-dom";
import LoadJscript from "../components/LoadJscript";
import Newsletter from "../components/Newsletter";
import API_URLS from "../config/apiConfig";
import swal from 'sweetalert';
import { ClipLoader } from "react-spinners";

const Signup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear errors on input change
  };

  // Validate form inputs
  const validate = () => {
    const newErrors = {};

    if (!formData.first_name.trim()){ newErrors.first_name = "Please enter first name";}
    if (!formData.last_name.trim()){ newErrors.last_name = "Please enter last name";}
    if (!formData.email.trim()) {
      newErrors.email = "Please enter your email";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter valid email";
    }
    console.log(formData.password.length);
    if (!formData.password.trim()){ newErrors.password = "Please enter password";}
    if (formData.password.length<8){ newErrors.password = "Password must be at least 8 characters";}
    if (formData.password !== formData.confirm_password) {
      newErrors.confirm_password = "Passwords do not match";
    }

    return newErrors;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(API_URLS.REGISTER, formData);
      if(response.data.success==1){
      swal("Success", "Signup successful!", "success").then(() => {
        navigate("/login"); // Redirect to the target page
      });
     
      }else{
      swal("Error", response.data.message, "error");  
      }
      
      console.log(response.data); // Handle response
    } catch (error) {
      swal("Error", "Signup failed. Please try again.", "error");  
      console.error("Error:", error.response?.data || error.message);
    }finally {
      setLoading(false); 
    }
  };

    return (
      <main>
         {loading && (
                <div className="loader-overlay">
                    <ClipLoader color="#08A9E6" loading={loading} size={50} />
                </div>
            )}
       <div className="inner-banner inner-banner-bg3">
            <div className="container">
            
                <div className="inner-title text-center">
                    <h3>Sign up</h3>
                    <ul>
                        <li>
                        <Link to="/">Home</Link>
                        </li>
                        <li>Sign up</li>
                    </ul>
                </div>
            </div>
        </div>
      
        <div className="user-area pt-100 pb-70">
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-lg-6">
                        <div className="user-all-form">
                            <div className="contact-form">
                                <h3 className="user-title"> Sign up </h3>
                                <form id="signupForm" name="signupForm" method="post" onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control" name="first_name"  data-error="Username" placeholder="First Name" value={formData.first_name}  onChange={handleChange} />
                              {errors.first_name && <p style={{ color: "red" }}>{errors.first_name}</p>}
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control" name="last_name" data-error="Username" placeholder="Last Name"  value={formData.last_name}  onChange={handleChange}/>
                                                {errors.last_name && <p style={{ color: "red" }}>{errors.last_name}</p>}
                                            </div>
                                        </div>

                                        <div className="col-lg-12 ">
                                            <div className="form-group">
                                                <input type="email" className="form-control" name="email"  data-error="Please enter Email" placeholder="Please Enter Email"  value={formData.email}  onChange={handleChange}/>
                                                {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <input className="form-control" type="password" name="password" placeholder="Password" value={formData.password}  onChange={handleChange}/>
                                                {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <input className="form-control" type="password" name="confirm_password" placeholder="Confirm Password" value={formData.confirm_password}  onChange={handleChange}/>
                                                {errors.confirm_password && <p style={{ color: "red" }}>{errors.confirm_password}</p>}
                                            </div>
                                        </div>
                                        <div className="col-lg-12 form-condition">
                                            <div className="agree-label">
                                                
                                               
                                               <span> Already have an account </span>
                                               <span> 
                                                 <Link className="forget float-end" to="/login">Login Now</Link></span>
                                              
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <button type="submit" className="default-btn" disabled={loading}>
                                            {loading ? "Submitting..." : "Register Now"}
                                            </button>
                                            
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="user-img">
                            <img src="/assets/images/faq-img.jpg" alt="faq" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <Newsletter/>
        <LoadJscript/>
      </main>
    );
  }
  export default Signup;  